import React, { useEffect, useState } from 'react';
import { useBlockingRouter } from '../../../../hooks/useBlockingRouter';

import { SideNavButtonItem } from '../SideNavButtonItem/SideNavButtonItem';
import useMenu from '../../../../hooks/useMenu';
import { CustomListItemList } from '../../CustomListItemList/CustomListItemList';
import CustomMenu from '../../../../mui/CustomMenu/CustomMenu';
import styles from './SideNavDropdownItem.module.scss';
import { DropdownType } from '../SideNavContainer';
import { isSideNavRouteActive } from '../helpers';

export default function SideNavDropdownItem( {
	listItem: { id, label, icon, items },
}: {
	listItem: DropdownType;
} ) {
	const { anchorEl, open, handleClick, handleClose } = useMenu();
	const [ isActive, setIsActive ] = useState( false );
	const router = useBlockingRouter();
	const currentPath = router.asPath;

	useEffect( () => {
		setIsActive(
			items.some( ( item ) =>
				'href' in item ? isSideNavRouteActive( currentPath, item.href ) : false
			)
		);
	}, [ currentPath, items ] );

	return (
		<>
			<SideNavButtonItem
				listItem={ {
					id: id,
					onClick: handleClick,
					isActive: isActive,
					label: label,
					icon: icon,
					className: styles.sidenavItem,
				} }
			/>
			<CustomMenu
				anchorEl={ anchorEl }
				open={ open }
				className={ styles.dropdownMenu }
				onClose={ handleClose }
				onClick={ handleClose }
				slotProps={ {
					paper: {
						elevation: 0,
					},
				} }
				arrowPosition={ 'left' }
				data-cy={ 'sideNavDropdownMenu' }
			>
				<CustomListItemList items={ items } />
			</CustomMenu>
		</>
	);
}
